.row {
  display: grid;
  row-gap: 8px;
  column-gap: 8px;
  padding: 16px;
  gap: 16px;
}

.container {
  border-radius: 5px;
  background: var(--overlay);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
}

.image {
  width: 70px;
  height: 70px;
  border-radius: 5px;
  border: 0;
}

.fakeImage {
  width: 70px;
  height: 70px;
  border-radius: 5px;
  background-color: white;
}

.TitleLeTueFoto {
  color: var(--primary);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-top: 16px;
}
